export function getCapPayLink(baseUrl, txnID) {
	if (!txnID) return null;
	const url = new URL(baseUrl);
	url.searchParams.set('load_id', txnID);
	return url.toString();
}

export function openCapPayLink(baseUrl, txnID, open = window.open) {
	const url = getCapPayLink(baseUrl, txnID);
	if (!url) return false;
	open(url, '_blank', 'noopener,noreferrer');
	return true;
}

export function openCapPayLinkForRow(rows, rowIdx, baseUrl, open = window.open) {
	return openCapPayLink(baseUrl, rows[rowIdx] && rows[rowIdx].txnID, open);
}